/**
 * A source-of-truth dictionary of all URL params that we manually control or override by name
 */
export const manualUrlParams = {
  SEARCH_TERM: 'searchTerm',
  PAGE: 'page',
  REVERSE: 'reverse',
};
